<template>
	<div class="contact-icon" :class="{ disabled: disabled }">
		<span>{{ getInitials(firstName, lastName) }}</span>
	</div>
</template>

<script>
import { getInitials } from './helpers';

export default {
	name: 'ContactIcon',
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		firstName: String,
		lastName: String,
	},
	methods: {
		getInitials,
	},
};
</script>

<style lang="scss" scoped>
.contact-icon {
	@include rem('width', 44px);
	@include rem('height', 44px);
	@include rem('font-size', 20px);
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	background: $brand-blue;
	color: $white;
}
.disabled {
	background: $b360-color--gray__medium-plus;
}
</style>
